module.exports = __webpack_public_path__ + "img/09.a5ae6a55.jpg";